module.exports = __webpack_public_path__ + "img/email.35a0972a.svg";